import { defineStore } from "pinia";
import { client, urls, setTimezone } from "@/apiClient";

export const useTimeZoneStore = defineStore("timezoneStore", {
  state: () => ({
    timezone: null,
  }),
  actions: {
    async fetchTimeZone(brandId) {
      try {
        const { data } = await client.get(urls.getTimePickerDataUrl);

        if (data?.timezone) {
          this.timezone = data.timezone;
          setTimezone(data.timezone);
        }
      } catch (error) {
        console.error("Failed to fetch timezone:", error);
      }
    },
  },
});